import { RuleExecutionLog } from '@rossum/api-client/rulesExecutionLogs';
import { alpha, SxProps, Theme } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import { gridClasses } from '@rossum/ui/x-data-grid-pro';

export const getTransformedRulesExecutionLogs = (logs: RuleExecutionLog[]) =>
  logs.map(log => ({
    ...log,
    id: `${log.requestId}-${log.ruleId}-${log.createdAt}`,
  }));

export type TransformedRuleExecutionLog = ReturnType<
  typeof getTransformedRulesExecutionLogs
>[number];

export const rulesExecutionLogsDataGridStyles: SxProps<Theme> = {
  backgroundColor: 'transparent',
  [`.${gridClasses.columnHeader}`]: {
    backgroundColor: 'transparent',
  },
  [`.${gridClasses.row}`]: {
    borderBottom: 'none',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  [`.${gridClasses.row}.Mui-hovered`]: {
    backgroundColor: 'transparent',
  },
  [`.${gridClasses.detailPanel}`]: {
    backgroundColor: t => t.palette.background.paper,
    marginTop: '-1px',
    border: t => `1px solid ${alpha(t.palette.divider, 0.06)}`,
    borderTopColor: 'transparent',
    borderBottomLeftRadius: t => borderRadius.abs(t.shape.borderRadius, 'm'),
    borderBottomRightRadius: t => borderRadius.abs(t.shape.borderRadius, 'm'),
  },
  [`.${gridClasses.columnHeaders}, .${gridClasses.cell}`]: {
    border: 'none',
    backgroundColor: 'transparent',
  },
};

export const formatToJSONString = (value: unknown) =>
  JSON.stringify(value, null, 2);

// Helper to determine if it's a line item rule (multiple lines)
export const isLineItemRule = (log: RuleExecutionLog): boolean =>
  log.triggerConditionResults.length > 1;
